/* ============================================================
   WESTSIDE BARBELL — BLOG JS
   1. Predictive article search (Shopify Predictive Search API)
   2. Imported-content cleanup (legacy Word/old-site HTML)
   3. Auto table of contents from article H2s + nested H3s
   4. FAQ accordion + schema; progress ring; snippets; copy link
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Predictive article search ---------- */
  var searchInput = document.querySelector('[data-wsbb-search-input]');
  var searchResults = document.querySelector('[data-wsbb-search-results]');
  var debounceTimer;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = searchInput.value.trim();
      if (!q.length) { searchResults.hidden = true; return; }
      debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 250);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-wsbb-search]')) searchResults.hidden = true;
    });

    function fetchSuggestions(q) {
      var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root : '/';
      url += 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=article&resources[limit]=6&resources[options][fields]=title,body';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (searchInput.value.trim() !== q) return; // stale response — query changed
          var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
          searchResults.innerHTML = '';
          if (!articles.length) {
            searchResults.innerHTML = '<div class="wsbb-search__empty">No articles found</div>';
          } else {
            articles.forEach(function (a) {
              var link = document.createElement('a');
              link.href = a.url;
              link.textContent = a.title;
              searchResults.appendChild(link);
            });
          }
          searchResults.hidden = false;
        })
        .catch(function () { searchResults.hidden = true; });
    }
  }

  var content = document.querySelector('[data-wsbb-content]');

  /* ---------- 2. Imported-content cleanup ----------
     Legacy posts (Word / old-site HTML) ship tables padded with empty
     spacer rows and columns — they render as broken ghost cells. Drop
     any row or column that is empty across the whole table, then wrap
     tables for horizontal scroll on narrow screens. Word layout divs
     (page/layoutArea/column) are unwrapped via CSS display:contents. */
  if (content) {
    content.querySelectorAll('table').forEach(function (tbl) {
      var cellEmpty = function (c) { return !c.textContent.trim() && !c.querySelector('img,iframe'); };
      var rows = Array.prototype.slice.call(tbl.rows);
      rows.forEach(function (r) {
        if (Array.prototype.every.call(r.cells, cellEmpty)) r.remove();
      });
      rows = Array.prototype.slice.call(tbl.rows);
      if (!rows.length) { tbl.remove(); return; }
      // Column removal is only safe when no cell spans rows/columns
      var usesSpans = rows.some(function (r) {
        return Array.prototype.some.call(r.cells, function (c) { return c.colSpan > 1 || c.rowSpan > 1; });
      });
      if (!usesSpans) {
        var maxCols = 0;
        rows.forEach(function (r) { maxCols = Math.max(maxCols, r.cells.length); });
        for (var col = maxCols - 1; col >= 0; col--) {
          var allEmpty = rows.every(function (r) { return !r.cells[col] || cellEmpty(r.cells[col]); });
          if (allEmpty) {
            rows.forEach(function (r) { if (r.cells[col]) r.cells[col].remove(); });
          }
        }
      }
      if (!tbl.parentElement.classList.contains('wsbb-table-scroll')) {
        var wrap = document.createElement('div');
        wrap.className = 'wsbb-table-scroll';
        tbl.before(wrap);
        wrap.appendChild(tbl);
      }
    });
  }

  /* ---------- 3. Auto table of contents ----------
     H2s = numbered entries; H3s nest under their parent H2 with letter
     labels. Skipped: empty headings (imported posts have blank h2s),
     pull-quote headings inside blockquotes, and H3s in a FAQ section
     (those become accordions in step 4). */
  var toc = document.querySelector('[data-wsbb-toc]');
  var tocList = document.querySelector('[data-wsbb-toc-list]');
  var faqRe = /^(faqs?|frequently asked)/i;

  if (toc && tocList && content) {
    var currentH2Li = null;
    var currentSub = null;
    var inFaq = false;
    var h2Count = 0;
    var idSeq = 0;
    content.querySelectorAll('h2, h3').forEach(function (h) {
      var text = h.textContent.trim();
      if (!text || h.closest('blockquote')) return;
      idSeq++;
      if (!h.id) {
        h.id = 'section-' + idSeq + '-' + text.toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').slice(0, 60);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      if (h.tagName === 'H2') {
        inFaq = faqRe.test(text);
        tocList.appendChild(li);
        currentH2Li = li;
        currentSub = null;
        h2Count++;
      } else {
        if (inFaq || !currentH2Li) return;
        if (!currentSub) {
          currentSub = document.createElement('ol');
          currentH2Li.appendChild(currentSub);
        }
        currentSub.appendChild(li);
      }
    });
    if (h2Count >= 2) {
      toc.hidden = false;
    } else {
      tocList.innerHTML = '';
    }
  }

  /* ---------- 4. FAQ accordion + FAQPage schema ----------
     Convention: an H2 whose text starts with "FAQ" or "Frequently Asked"
     marks the FAQ section. Each following H3 = question; the nodes until
     the next H3/H2 = answer. Converts to <details> accordions and injects
     FAQPage JSON-LD. Writers author plain H3s + paragraphs — no shortcode. */
  if (content) {
    var faqHead = Array.prototype.find.call(content.querySelectorAll('h2'), function (h) {
      // Skip DropInBlog placeholder wrappers and headings with nothing after them
      return faqRe.test(h.textContent.trim()) &&
        !h.closest('.dib-faq') && h.nextElementSibling;
    });
    if (faqHead) {
      var faqData = [];
      var node = faqHead.nextElementSibling;
      while (node && !(node.tagName === 'H2')) {
        if (node.tagName === 'H3') {
          var q = node.textContent.trim();
          var details = document.createElement('details');
          details.className = 'wsbb-faq-item';
          var summary = document.createElement('summary');
          summary.textContent = q;
          details.appendChild(summary);
          var answerWrap = document.createElement('div');
          answerWrap.className = 'wsbb-faq-item__a';
          var next = node.nextElementSibling;
          var answerText = [];
          while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
            var moved = next;
            next = next.nextElementSibling;
            answerWrap.appendChild(moved);
            answerText.push(moved.textContent.trim());
          }
          details.appendChild(answerWrap);
          node.replaceWith(details);
          node = next;
          faqData.push({ q: q, a: answerText.join(' ') });
        } else {
          node = node.nextElementSibling;
        }
      }
      if (faqData.length) {
        var ld = {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          'mainEntity': faqData.map(function (f) {
            return {
              '@type': 'Question',
              'name': f.q,
              'acceptedAnswer': { '@type': 'Answer', 'text': f.a }
            };
          })
        };
        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(ld);
        document.head.appendChild(script);
      }
    }
  }

  /* ---------- 5. Reading progress circle ----------
     Circular indicator (DropInBlog-style) showing article scroll progress.
     Markup: <div class="wsbb-progress"><span data-wsbb-progress></span></div>
     Rendered as an SVG ring, fixed bottom-right; click = back to top. */
  var progressHost = document.querySelector('.wsbb-progress');
  if (progressHost && content) {
    progressHost.innerHTML =
      '<svg viewBox="0 0 44 44" width="44" height="44" role="img" aria-label="Reading progress">' +
      '<circle class="wsbb-progress__track" cx="22" cy="22" r="18"/>' +
      '<circle class="wsbb-progress__fill" cx="22" cy="22" r="18" data-wsbb-progress-ring/>' +
      '</svg><span class="wsbb-progress__pct" data-wsbb-progress-pct></span>';
    var ring = progressHost.querySelector('[data-wsbb-progress-ring]');
    var pctEl = progressHost.querySelector('[data-wsbb-progress-pct]');
    var C = 2 * Math.PI * 18;
    ring.style.strokeDasharray = C;
    ring.style.strokeDashoffset = C;
    var ticking = false;
    function updateProgress() {
      var rect = content.getBoundingClientRect();
      var winH = window.innerHeight;
      var total = rect.height - winH;
      var done = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      var pct;
      if (total > 0) {
        pct = done / total;
      } else {
        // Article shorter than viewport: base progress on how much has entered view
        pct = rect.bottom <= winH ? 1 : Math.min(Math.max((winH - rect.top) / rect.height, 0), 1);
      }
      pct = Math.min(Math.max(pct, 0), 1);
      ring.style.strokeDashoffset = C * (1 - pct);
      pctEl.textContent = Math.round(pct * 100) + '%';
      progressHost.classList.toggle('is-visible', rect.top < winH * 0.5);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(updateProgress); }
    }, { passive: true });
    progressHost.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    updateProgress();
  }

  /* ---------- 6. Mid-content smart snippets ----------
     Snippets rendered with data-wsbb-inject-after-p="N" are moved into the
     article after the Nth top-level paragraph, then unhidden. */
  if (content) {
    document.querySelectorAll('[data-wsbb-inject-after-p]').forEach(function (snip) {
      var n = parseInt(snip.getAttribute('data-wsbb-inject-after-p'), 10) || 1;
      // Imported posts often wrap paragraphs in nested divs — use all
      // descendant paragraphs, excluding accordions/TOC internals.
      var paras = Array.prototype.filter.call(content.querySelectorAll('p'), function (par) {
        return !par.closest('details');
      });
      if (!paras.length) { snip.remove(); return; }
      var anchor = paras[Math.min(n, paras.length) - 1];
      anchor.after(snip);
      snip.hidden = false;
    });
  }

  /* ---------- 7. Copy link ---------- */
  var copyBtn = document.querySelector('[data-wsbb-copylink]');
  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(copyBtn.dataset.url).then(function () {
        var prev = copyBtn.textContent;
        copyBtn.textContent = '✓';
        setTimeout(function () { copyBtn.textContent = prev; }, 1500);
      });
    });
  }
})();

  /* ---------- Klaviyo signup fallback ----------
     The Klaviyo embed is injected by Klaviyo's own app block. If it is absent
     (a store without the app) or slow/blocked, the slot stays empty — so after
     a short grace period, reveal the native customer form instead of leaving a
     blank panel where the signup should be. */
  (function () {
    var slots = document.querySelectorAll('[data-wsbb-klaviyo]');
    if (!slots.length) return;
    setTimeout(function () {
      Array.prototype.forEach.call(slots, function (slot) {
        if (slot.children.length) return;                 // Klaviyo rendered
        var wrap = slot.parentNode;
        if (!wrap) return;
        var fb = wrap.querySelector('[data-wsbb-signup-fallback]');
        if (fb) { fb.hidden = false; slot.remove(); }
      });
    }, 2500);
  })();

  /* ---------- Collapsible author bio ----------
     The bio ships expanded so it reads in full without JS. Clamp it here and
     show the toggle, but only when it actually overflows three lines — a
     one-line bio with a "Read more" under it is just noise. */
  (function () {
    var bios = document.querySelectorAll('[data-wsbb-bio]');
    if (!bios.length) return;

    // Measure after webfonts land — the clamp is a line count, and the
    // fallback face wraps differently enough to misjudge a borderline bio.
    var ready = document.fonts && document.fonts.ready
      ? document.fonts.ready
      : { then: function (f) { f(); } };

    ready.then(function () { Array.prototype.forEach.call(bios, setup); });

    function setup(bio) {
      var text = bio.querySelector('.wsbb-bio__text');
      var btn = bio.querySelector('.wsbb-bio__toggle');
      if (!text || !btn) return;

      bio.classList.add('wsbb-bio--collapsed');
      if (text.scrollHeight <= text.clientHeight + 1) {
        bio.classList.remove('wsbb-bio--collapsed');   // fits; leave it open
        return;
      }

      bio.classList.add('wsbb-bio--enhanced');
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var open = bio.classList.toggle('wsbb-bio--collapsed') === false;
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  })();
